import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';
import { GetRecommendedProgramParams } from '@src/api/programs.ts';

export const useRecommendedProgramQuery = (params: GetRecommendedProgramParams) => {
  return useQuery({
    queryKey: ['recommendedProgram', params],
    queryFn: async () => await API.programs.getRecommended(params),
    enabled: typeof params.hash !== 'undefined',
  });
};
